var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReturnToTopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4999 96.5214C75.022 96.5214 96.5223 75.021 96.5223 48.499C96.5223 21.9769 75.022 0.476562 48.4999 0.476562C21.9779 0.476562 0.477539 21.9769 0.477539 48.499C0.477539 75.021 21.9779 96.5214 48.4999 96.5214Z",
    fill: "#DCC9CE",
    stroke: "black",
    strokeWidth: 0.955259,
    strokeDasharray: "1.91 3.82 15.28 7.64"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_582_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.625 46.8438L48.5 26.9688L68.375 46.8438H58.4375V53.4688H38.5625V46.8438H28.625Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4375 66.7188H38.5625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4375 60.0938H38.5625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_3988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_582_3988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(22 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnToTopIcon);
export default __webpack_public_path__ + "static/media/returnToTopIcon.3d2bf2dc9631b2b850047f54a2074654.svg";
export { ForwardRef as ReactComponent };